import { formatDate, gridSizeMdLg6 } from "@/shared";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

interface CardComisionComponenteProps {
  monto: string;
  total: string;
  tipo: string;
}
export default function CardComisionComponente({ monto, total, tipo }: CardComisionComponenteProps) {

  return <Grid item {...gridSizeMdLg6} >
    <Card sx={{ width: '100%', border: '1px solid #EFEEEE' }} elevation={5}>|
      <CardContent>
        <Grid container alignItems="center">
          <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center' }}>
            <AttachMoneyIcon color="warning" sx={{ fontSize: 70 }} />
          </Grid>
          <Grid item xs={10}>
            <Typography variant="subtitle1" >
              Monto: ${monto}
            </Typography>
            <Typography variant="subtitle1" >
              Total de Ventas: {total}
            </Typography>
            <Typography variant="subtitle1" >
              {tipo}
            </Typography>
            <Typography variant="subtitle1" >
              Del: <span style={{ fontWeight: 'bold' }}>2024-01-01</span> Al: <span style={{ fontWeight: 'bold' }}>{formatDate(new Date)}</span>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  </Grid>

}